import {
  Flexbox,
  Heading,
  Label,
  Sizes,
} from '@sede-enterprise/shell-ds-react-framework';
import { useStore } from 'store';
import styled from 'styled-components';

const ChevronDown = ({ theme }: { theme: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M4.12008 8.64639C3.92482 8.84165 3.92482 9.15823 4.12008 9.35349L11.6463 16.8797C11.8415 17.075 12.1581 17.075 12.3534 16.8797L19.8796 9.35349C20.0748 9.15823 20.0748 8.84165 19.8796 8.64639L19.1726 7.93942C18.9773 7.7441 18.6606 7.74416 18.4653 7.93955L11.9998 14.4101L5.53429 7.93955C5.33905 7.74416 5.02237 7.7441 4.82705 7.93942L4.12008 8.64639Z"
        fill={theme === 'light' ? '#343434' : '#FFFFFF'}
        fillOpacity="0.994"
      />
    </svg>
  );
};

const Container = styled.button`
  appearance: none;
  border: none;
  outline: none;
  background: transparent;
  cursor: pointer;
`;

export const CompanySiteSelectorToggle = ({
  companyName,
  site,
}: {
  companyName: string | undefined;
  site: string | undefined;
}) => {
  const [appTheme, setMobileCompanySiteDrawerOpen] = useStore((state) => [
    state.appTheme,
    state.setMobileCompanySiteDrawerOpen,
  ]);

  const handleClick = () => {
    setMobileCompanySiteDrawerOpen();
  };
  return (
    <Container onClick={handleClick}>
      <Flexbox flexDirection={'column'} alignItems={'center'} gap={'4px'}>
        <Flexbox flexDirection={'row'} alignItems={'center'} gap={'4px'}>
          <Heading level={4} bold>
            {companyName}
          </Heading>
          <ChevronDown theme={appTheme} />
        </Flexbox>
        <Label size={Sizes.Medium} prominence={'subtle'}>
          {site}
        </Label>
      </Flexbox>
    </Container>
  );
};
